import { useNavigate } from "react-router-dom";
import { useApiQuery } from "../../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { routePaths } from "../../../../../common/infrastructure/routes/routePaths";
import { useStudioRelationsWizardForm } from "./useStudioRelationsWizardForm";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { SubmitHandler } from "react-hook-form";
import { IStudioRelationsWizardFormModel } from "../models/studioRelationsWizardFormModel";
import { getSuccessToast } from "../../../../../common/infrastructure/utilities/toastUtility";
import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";

export const useStudioRelationsWizardPage = () => {
  const navigate = useNavigate();
  const { mutate: mutate } = useApiMutation();

  const { data: allStudios, isLoading: isStudiosLoading } = useApiQuery<
    ISelectFieldModel[]
  >({
    queryKey: [endpointsMetadata.studioRelations.getAllEligibleStudios],
    endpoint: endpointsMetadata.studioRelations.getAllEligibleStudios,
  });

  const form = useStudioRelationsWizardForm(allStudios);

  const onSave: SubmitHandler<IStudioRelationsWizardFormModel> = async (
    data
  ) => {
    mutate(
      {
        endpoint: endpointsMetadata.studioRelations.addStudioConnection,
        globalIsLoading: true,
        method: "post",
        invalidateKeys: [[endpointsMetadata.studioRelations.getAllConnections]],
        ...data,
      },
      {
        onSuccess: () => {
          getSuccessToast("Успешна операция.");
          navigate(routePaths.studioRelations);
        },
      }
    );
  };

  return { form, isStudiosLoading, allStudios, onSave };
};
